import { z } from 'zod';

// POST /admin/investments/{investment}/rollover — v1.17.0. `note` is
// optional, same pattern as CloseInvestmentForm's `reason`: an admin can
// trigger a rollover with no explanation given. Capped to match the
// server's documented note length elsewhere in this domain (payouts/
// payments notes are all capped at 2000).
export const rollOverSchema = z.object({
  note: z.string().max(2000, 'Note must be 2000 characters or fewer').optional(),
});

// DELETE /admin/investments/{investment}/rollover — v1.17.0. `reason` is
// required here (unlike closing an investment or requesting a rollover):
// cancelling something that was already scheduled to execute automatically
// is the one action in this domain where the UI insists on an explanation,
// since it silently changes what the investor was expecting to happen.
export const cancelRolloverSchema = z.object({
  reason: z.string().min(1, 'A reason is required.').max(500, 'Reason must be 500 characters or fewer'),
});

export default rollOverSchema;
